let loaderLock = false;

export const showLoader = (param, options = {}) => {
    const loaderElement = document.querySelector('.spLoader');
    if (options.lock !== undefined) {
        loaderLock = options.lock;
    }

    if (loaderLock && param === false) {
        return; // 🚫 ignore hide while locked
    }
    if (!loaderElement) {
        return;
    }

    if (param === true) {
        loaderElement.classList.add("showLoader");
    } else {
        loaderElement.classList.remove("showLoader");
    }
}